<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
            <p></p>
            <v-alert
              class="text-left"
              dense
              outlined
              type="info"
            >
              โปรดใส่ข้อมูลชุดนี้ตามความเป็นจริง เพื่อให้บริษัทได้ช่วยเหลือท่าน
            </v-alert>
            <div>
              <v-overlay :value="dataReady">
                <div class="text-center">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>

    <v-progress-circular
      :width="3"
      color="red"
      indeterminate
    ></v-progress-circular>

    <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>

    <v-progress-circular
      :width="3"
      color="green"
      indeterminate
    ></v-progress-circular>

    <v-progress-circular
      :size="50"
      color="amber"
      indeterminate
    ></v-progress-circular>
  </div>
</v-overlay>
<v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>ขอความช่วยเหลือ</v-expansion-panel-header>
                  <v-expansion-panel-content>
                   <v-container fluid>
                    <v-card-text>
                      <v-row style="height: 35px">
                        <v-card>
                          <br />
                          <v-subheader id="subtext"
                            ><strong
                              >กรณีขอความช่วยเหลือท่านมีความประสงค์ให้ทางบริษัทช่วยเหลือท่านเรื่องใดบ้าง</strong
                            ></v-subheader
                          >
                          <br />
                        </v-card>
                      </v-row>
                      <br />

                      <v-container fluid>
                        <br />
                        <br />
                          <v-select
                          v-model="formAdd.empHelpRequest"
                            :items="dataItemHelp"
                            label="ความช่วยเหลือ"
                            :rules="[v => !!v || 'กรุณา เลือก 1 รายการ']"
                            dense
                            outlined
                          ></v-select>
                        <v-col
                          cols="12"
                        >
                        <v-checkbox
                          v-model="formAdd.empHelpChoice"
                          label="อาหาร/น้ำดื่ม"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formAdd.empHelpChoice1"
                          label="ยาสามัญ"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formAdd.empHelpChoice2"
                          label="ที่พักอาศัย(ชั่วคราว)"
                        ></v-checkbox>
                        </v-col>
                      </v-container>

                      <v-row style="height: 35px">
                        <v-subheader id="subtext">อื่นๆ</v-subheader>
                      </v-row>
                      <v-row style="height: 50px">
                        <v-col cols="12">
                          <v-textarea
                            v-model="formAdd.empHelpDetail"
                            auto-grow
                            filled
                            color="deep-purple"
                            placeholder="กรอกอื่นๆที่ต้องการ"
                            rows="2"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <br />
                      <br />
                      <br />

                      <v-file-input
                        v-model="files"
                        :rules="rules"
                        dense
                        outlined
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="แนบรูป 1"
                      ></v-file-input>
                      <v-file-input
                        v-model="files2"
                        :rules="rules"
                        dense
                        outlined
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="แนบรูป 2"
                      ></v-file-input>
                      <v-file-input
                        v-model="files3"
                        :rules="rules"
                        dense
                        outlined
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="แนบรูป 3"
                      ></v-file-input>

                    </v-card-text>
                  </v-container>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      dark
                      depressed
                      :disabled="!formAdd.empHelpRequest"
                      @click="chkFile(formAdd)"
                    >
                      ส่งคำขอ
                    </v-btn>
                  </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
            </div>
            <v-card>
              <v-card
                class="mx-auto my-2 text-left"
                elevation="12"
                v-for="(items, index) in dataItem"
                :key="index"
              >
                <v-card-title>
                  <v-row>
                    <v-col>
                      <b>ขอความช่วยเหลือ</b>
                      <v-chip
                        class="ma-2"
                        color="amber "
                        text-color="white"
                        v-if="items.empHelpStatus == 'draft'"
                      >รอตรวจสอบ
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-card-text>
                    ขอความช่วยเหลือ:
                    <v-chip
                        class="ma-2"
                        color="primary "
                        text-color="white"
                      >{{items.empHelpRequest}}
                      </v-chip>
                      <br />
                    <v-divider></v-divider>
                  <v-card-text>
                    <div class="text--primary">
                      <v-row>
                        <v-container fluid>
                          รายการขอความช่วยเหลือ:
                          <v-chip v-if="items.empHelpChoice == 'True'"
                            >อาหาร/น้ำดื่ม</v-chip
                          >
                          <v-chip v-if="items.empHelpChoice1 == 'True'"
                            >ยาสามัญ</v-chip
                          >
                          <v-chip v-if="items.empHelpChoice2 == 'True'"
                            > ที่พักอาศัย(ชั่วคราว)</v-chip
                          >
                          <v-chip v-if="items.empHelpDetail == 'True'"
                            >{{items.empHelpDetail}}</v-chip
                          >
                        </v-container>
                      </v-row>
                    </div>
                  </v-card-text>
                  </v-card-text>
                </v-card-title>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
// import VuetifyLogo from '../logo'
import moment from 'moment' // แปลง date
export default {
  components: {
    // VuetifyLogo
  },
  name: 'VaccinHistory',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      dataReady: false,
      profile: [],
      panel: [0, 1],
      formAdd: [],
      dataItem: [],
      dataItemHelp: [],
      files: null,
      files2: null,
      files3: null,
      valid: true,
      rules: [
        value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!'
      ],
      imageUrlBack: '',
      imageHeadHRM: '',
      items: ['อัคคีภัย(ไฟไหม้)', 'วาตภัย(พายุ)', 'อุทกภัย(น้ำท่วม)', 'ภัยอันเกิดจากโรคที่แพร่หรือระบาดในมนุษย์', 'อื่นๆ']
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')

    let date = new Date()
    this.year = moment().format('YYYY')
    this.month = date.getMonth() + 1
    this.day = date.getDate()

    await this.getData()
    await this.getDataHelp()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      this.dataReady = true
      this.dataItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_help/get?empCode=" + this.profile.empCode
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItem = response.data
          }
          this.dataReady = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataItem = []
          this.dataReady = false
        })
    },
    async getDataHelp () {
      this.dataItemHelp = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_help/get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          let rs = response.data
          console.log('response', response.data)
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.masHelpCode
              s.text = d.masHelpName
              this.dataItemHelp.push(s)
            }
          } else {
            this.dataItemHelp = []
          }
        })
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.profile)

      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Help'
              }
            })
            .then(function (response) {
              console.log('file', response.data)
              _this.formAdd.empHelpFiles = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.empHelpFiles = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.files2)
      params.append('profile', _this.profile)

      if (_this.files2.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Help'
              }
            })
            .then(function (response) {
              console.log('file', response.data)
              _this.formAdd.empHelpFiles2 = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.empHelpFiles2 = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files2 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files2 = null
      }
    },
    async fileupload3 () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.files3)
      params.append('profile', _this.profile)

      if (_this.files3.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode,
                Topic: 'Help'
              }
            })
            .then(function (response) {
              console.log('file', response.data)
              _this.formAdd.empHelpFiles3 = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.empHelpFiles3 = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files3 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files3 = null
      }
    },
    async addData (dt) {
      this.dataReady = true

      this.month = this.month !== '' ? this.month : moment().format('M')
      this.year = this.year !== '' ? this.year : moment().format('YYYY')
      this.day = this.day !== '' ? this.day : moment().format('D')
      console.log('day', this.day)
      console.log('month', this.month)
      console.log('year', this.year)

      if (this.files) {
        await this.fileupload()
      }
      if (this.files2) {
        await this.fileupload2()
      }
      if (this.files3) {
        await this.fileupload3()
      }

      let ds = {
        empCode: this.profile.empCode,
        empHelpRequest: dt.empHelpRequest,
        empHelpDetail: dt.empHelpDetail,
        empHelpFiles: dt.empHelpFiles,
        empHelpFiles2: dt.empHelpFiles2,
        empHelpFiles3: dt.empHelpFiles3,
        empHelpStatus: 'draft',
        empHelpChoice: dt.empHelpChoice,
        empHelpChoice1: dt.empHelpChoice1,
        empHelpChoice2: dt.empHelpChoice2,
        empHelpDay: this.day,
        empHelpMonth: this.month,
        empHelpYear: this.year,
        CREATE_USER: this.profile.userName,
        LAST_USER: this.profile.userName
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_help/add",
          ds
        )
        .then(async (response) => {
          console.log('response', response)
          this.dataReady = false
          await this.linenotify(ds)
          this.getData()
          this.clearData()
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async linenotify (dt) {
      dt.empHelpChoice = dt.empHelpChoice === true ? '✅' : '🚫'
      dt.empHelpChoice1 = dt.empHelpChoice1 === true ? '✅' : '🚫'
      dt.empHelpChoice2 = dt.empHelpChoice2 === true ? '✅' : '🚫'
      dt.empHelpChoice3 = dt.empHelpChoice3 === true ? '✅' : '🚫'
      dt.empHelpChoice4 = dt.empHelpChoice4 === true ? '✅' : '🚫'
      dt.empHelpDetail = dt.empHelpDetail != null ? dt.empHelpDetail : '🚫'
      var massageNoti = 'ขอความช่วยเหลือ' +
            '\nเรื่อง: ' + dt.empHelpRequest +
            '\nชื่อพนักงาน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel +
            '\nรายการขอความช่วยเหลือ:' +
            '\n  อาหาร/น้ำดื่ม: ' + dt.empHelpChoice +
            '\n  ยาสามัญ: ' + dt.empHelpChoice1 +
            '\n  ที่พักอาศัย(ชั่วคราว): ' + dt.empHelpChoice2 +
            '\n  อื่นๆ: ' + dt.empHelpDetail
      let ds = {
        token: 'yc8wsCkux5MyRqTnsTl0QrbDnmoU55UXH5cyxTCeizQ', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    clearData () {
      this.panel = [1]
      this.formAdd = []
      this.files = null
      this.files2 = null
      this.files3 = null
    },
    async chkFile (formAdd) {
      this.$refs.form.validate()
      if (this.files !== null || this.files2 !== null || this.files3 !== null) {
        this.addData(formAdd)
      } else {
        this.$swal('อุ๊บ!!!', 'กรุณาแนบรูป อย่างน้อย 1 รูป', 'error')
      }
    }

  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/EmployeeAddHelp.vue